<svg width="82" height="109" viewBox="0 0 82 109" fill="none" xmlns="http://www.w3.org/2000/svg">
  <path
    class="preloader-logo-ebarn"
    fill-rule="evenodd"
    clip-rule="evenodd"
    d="M15.4276 1V31.2814C3.29438 44.0156 -1.31777 55.9477 2.09172 74.2971C6.30273 91.6437 21.6437 108.389 48.2154 107.386C56.187 107.077 67.3667 102.852 76.0907 93.8496L67.668 86.931C62.554 92.3456 53.0777 97.2019 43.9038 96.7574C34.73 96.313 29.9664 94.0502 23.148 88.9364C14.7254 82.6194 6.70381 65.2728 15.3269 48.628V53.2404C14.7881 67.7274 27.2597 84.9256 44.9068 86.0286C62.554 87.1316 75.6893 76.3024 79.7004 62.6658C83.7115 49.0291 77.8952 34.8911 69.6734 28.0728C61.4516 21.2545 50.8224 19.5499 40.4947 20.352C34.7137 20.801 28.7631 22.7585 26.2567 24.5633V1H15.4276ZM26.3566 55.7472V36.7962C29.2645 34.49 35.4752 31.1956 47.0122 31.3817C59.4456 31.5822 69.1864 39.8964 69.5728 52.9396C69.9739 66.476 57.741 75.2998 48.0149 74.8987C35.3809 75.4 26.1561 63.1671 26.3566 55.7472Z"
    fill="#189E67"
    stroke="#189E67"
    stroke-width="3"
    stroke-linecap="round"
    stroke-linejoin="round"
  ></path>
</svg>
